import { render, staticRenderFns } from "./trainingModuleQuestion.vue?vue&type=template&id=10bb44c6&scoped=true&"
import script from "./trainingModuleQuestion.vue?vue&type=script&lang=js&"
export * from "./trainingModuleQuestion.vue?vue&type=script&lang=js&"
import style0 from "./trainingModuleQuestion.vue?vue&type=style&index=0&id=10bb44c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bb44c6",
  null
  
)

export default component.exports